import React, { useMemo, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import "../Home_css/Financing.css";
import { Container, Accordion, Row, Col } from "react-bootstrap";
import opastionb from "../../Assets/PTx-Download_PDFs/RC_Quick_Application.pdf";
import financingImage from '../../Assets/Dahlia_images/finance_bed.webp';


const FullScreenAccordion = () => {
  const handleDownload = useCallback((fileUrl) => {
    if (fileUrl) window.open(fileUrl, "_blank");
  }, []);
  const accordionData = useMemo(() => [
    {
      title: "OPTION A",
      content: (
        <>
          <p className="financing">
            Dahlia Health works with NCMIC for licensed medical professionals. NCMIC specializes in healthcare equipment financing at competitive rates and offers a quick turnaround.
          </p>
          <ul>
            <li>Soft Credit Check - No hit to your credit report</li>
            <li>90-day payment deferment option available</li>
            <li>No early payoff penalty</li>
            <li>Simple online application</li>
          </ul>
          <h6>
            <a href="https://www.ncmic.com/expressapp" target="_blank" rel="noopener noreferrer">
              APPLY HERE
            </a>
          </h6>
        </>
      ),
    },
    {
      title: "OPTION B",
      content: (
        <>
          <p className="financing">
            For non-licensed buyers, Dahlia Health recommends Priority Capital and Newlane Finance. Both are excellent sources of financing for our systems and provide quick turnaround applications.
          </p>
          <ul>
            <li>Lower credit score requirements</li>
            <li>Simple online application</li>
            <li>Excellent staff that explore solutions from nearly 40 different lending sources</li>
          </ul>
          <h6>
            <a href="https://prioritycapital.com/equipment-financing/apply-now/" target="_blank" rel="noopener noreferrer">
              PRIORITY CAPITAL
            </a>
          </h6>
          <h6>
            <a href="https://newlanefinance.com/finance-application/?rep=Robbie-DeGaris" target="_blank" rel="noopener noreferrer">
              NEWLANE FINANCE
            </a>
          </h6>
        </>
      ),
    },
    {
      title: "OPTION C",
      content: (
        <>
          <p className="financing">
            For tougher credit situations, we recommend Reliant Capital. Reliant offers aggressive pricing and fast turnaround.
          </p>
          <ul>
            <li>Works with multiple vendors to find a solution</li>
            <li>Lower credit score requirements</li>
            <li>Simple, one-page application</li>
            <li>Professional staff with experience</li>
          </ul>
          <h6
            style={{ cursor: "pointer", color: "#A81f5e" }}
            onClick={() => handleDownload(opastionb)}
          >
            DOWNLOAD APPLICATION <FontAwesomeIcon icon={faDownload} />
          </h6>
        </>
      ),
    },
    {
      title: "TAX ADVANTAGES",
      content: (
        <p className="financing">
          The IRS allows businesses to expense the full purchase price of equipment during a tax year, up to $1,200,000 (in 2024). This represents a significant tax savings that allows you to keep more money in your account. In most cases, it is equivalent to receiving a 24% discount off our device.
        </p>
      ),
    },
  ], [handleDownload]);

  return (
    <section id="Financing">
      <Container id="financing">
        <Row className="align-items-center">
          {/* Text Content */}
          <Col lg={4} md={10} className="text-container">
            <div>
              <h3 className="top-text">Explore Our</h3>
              <h2 className="middle-text">Financing Options</h2>
              <h3 className="bottom-text">Made For You</h3>
            </div>
          </Col>

          {/* Image */}
          <Col lg={5} md={10} className="image-container">
          <img src={financingImage} alt="Financing Options" className="financing-image" />
            {/* <OptimizedImage 
              src="../../Assets/Website_Images/Finance_bg.webp"
              alt="fin"
              className="financing-image"

            /> */}
          </Col>
        </Row>

        {/* Accordion Section */}
        <Row>
          <Col>
            <Container className="mainContainerOne">
              <Accordion className="full-screen-container">
                {accordionData.map((item, index) => (
                  <Accordion.Item eventKey={index.toString()} key={item.title}>
                    <Accordion.Header>
                      <span>{item.title}</span>
                    </Accordion.Header>
                    <Accordion.Body>{item.content}</Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </Container>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default React.memo(FullScreenAccordion);
